export const ClothingResources = [
  {
    "name": "Portland Police Sunshine Division",
    "address": "687 N. Thompson St.",
    "city": "Portland, OR, 97227",
    "phone": "503-823-2102 ",
    "details": "Provides clothing to individuals and families. Must call in advance.",
    "services": "Clothing only"
  },
  {
    "name": "Rose Haven",
    "address": "627 NW 18th Ave",
    "city": "Portland, OR, 97209",
    "phone": "503-248-6364 ",
    "details": "By appointment only. Mon. -Thurs. Women only: Access center for clothing, hygiene, mailing address and voice mail.",
    "services": "Hygiene, mailing address and voice mail."
  },
  {
    "name": "St. Andre Bessette (Downtown Chapel)",
    "address": "601 W. Burnside St.",
    "city": "Portland, OR, 97209",
    "phone": "503-228-0746",
    "details": "Clothing for families in need. Clothing once every 30 days. Sleeping bags and backpacks depending on availability (Fri.).",
    "services": "Meals, foot care, hair cuts"
  }
];

export const MealResources = [
  {
    "name": "Blanchet House",
    "address": "310 NW Glisan St.",
    "city": "Portland, OR, 97209",
    "phone": "503-226-3911",
    "details": "6:30-7:30 a.m. (breakfast), 11:30 a.m.-12:30 p.m. (lunch), 5 p.m-6 p.m. (dinner), Monday-Saturday. ",
    "services": "Transitional housing"
  },
  {
    "name": "Potluck In The Park, O'Bryant Square",
    "address": "SW 9th Ave. at Washington St.",
    "city": "Portland, OR",
    "phone": "N/A",
    "details": "Lunch tickets given at 1 p.m. Meal serving begins at 3 p.m., Sun.",
    "services": "Meals only"
  },
  {
    "name": "Trinity Episcopal Cathedral",
    "address": "147 NW 19th Ave",
    "city": "Portland, OR, 97209",
    "phone": "503-872-0756 ",
    "details": "Hot community meals hours 11 a.m. - 1 p.m. Wed",
    "services": "Meals only"
  }
];

export const ShelterResources = [
  {
    "name": "Portland Rescue Mission",
    "address": "111 W. Burnside Ave",
    "city": "Portland, OR, 97209",
    "phone": "503-906-7690",
    "details": "Overnight shelter available for men only, based on a nightly lottery system (held at 6 p.m. ; TB card required)",
    "services": "Meals, mailing address, and clothing"
  },
  {
    "name": "City Team Ministries",
    "address": "526 SE Grand Ave",
    "city": "Portland, OR, 97214",
    "phone": "503-231-9334 ",
    "details": "Men only, TB card/sobriety required. $5 a night for shelter, meal included. Mon.-Sun. Sign up @ 5:45p.m",
    "services": "Meals"
  },
  {
    "name": "Goose Hollow Family Shelter",
    "address": "1838 SW Jefferson",
    "city": "Portland, OR, 97201",
    "phone": "",
    "details": "Temporary emergency shelter for homeless families with children.",
    "services": "Meals, showers, laundry"
  }
];